import React from 'react';
import { Row, Col } from '@cochlear-design-system/foundation';
import { Error } from '../../../ui/Error/Error';

export const DeceasedView = ({ config }) => {
  return (
    <Row>
      <Col xs={12}>
        <Error
          config={config.errorView}
          labels={config.labels}
          data={{}}
        />
      </Col>
    </Row>
  );
};
